// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3sQbk","upload":"Small_upload__w7qBj","imageWrap":"Small_imageWrap__3WOQv","removeBtn":"Small_removeBtn__3ElBm"};